"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Backdrop = _interopRequireDefault(require("../../Backdrop"));

var _Dialog = _interopRequireDefault(require("../../Dialog"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Close = _interopRequireDefault(require("../../Icons/Close"));

var _Portal = _interopRequireDefault(require("../../Portal"));

var _SlideableDrawer = _interopRequireDefault(require("../../SlideableDrawer"));

var _TouchableOpacity = _interopRequireDefault(require("../../TouchableOpacity"));

var _Content = _interopRequireDefault(require("./Content"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    backdrop: {
      zIndex: 1100
    },
    drawer: {
      zIndex: 1101,
      width: '100%'
    },
    mobile: {
      boxSizing: 'border-box',
      maxHeight: ['70vh', 'calc(80vh - constant(safe-area-inset-top) - constant(safe-area-inset-bottom))', 'calc(80vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))'],
      overflowX: 'hidden'
    },
    desktop: {
      boxSizing: 'border-box',
      minWidth: spacing(80),
      overflowX: 'hidden'
    },
    close: {
      position: 'absolute',
      bottom: spacing(-9),
      right: 0,
      left: 0,
      margin: 'auto',
      width: spacing(8)
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var SalaryDetails = function SalaryDetails(props) {
  var _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      variant = props.variant,
      onClose = props.onClose,
      other = (0, _objectWithoutProperties2["default"])(props, ["open", "variant", "onClose"]);
  var classes = useStyles();

  if (variant === 'desktop') {
    return (0, _core.jsx)(_Dialog["default"], {
      open: open,
      onClose: onClose
    }, (0, _core.jsx)(_Content["default"], (0, _extends2["default"])({
      css: classes.desktop,
      "data-testid": "SalaryDetails-DialogContent",
      flex: 1
    }, other)));
  }

  return (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)(_Backdrop["default"], {
    css: classes.backdrop,
    open: open,
    onClose: onClose
  }), (0, _core.jsx)(_Portal["default"], null, (0, _core.jsx)(_SlideableDrawer["default"], {
    PopperProps: {
      css: classes.drawer
    },
    elevation: 5,
    open: open,
    position: "top"
  }, (0, _core.jsx)(_Content["default"], (0, _extends2["default"])({
    css: classes.mobile,
    "data-testid": "SalaryDetails-DrawerContent",
    flex: 1
  }, other)), (0, _core.jsx)(_TouchableOpacity["default"], {
    onClick: onClose,
    css: classes.close,
    "data-testid": "SalaryDetails-Close"
  }, (0, _core.jsx)(_Icon["default"], {
    as: _Close["default"],
    size: 8,
    color: "inactive"
  })))));
};

__signature__(SalaryDetails, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = SalaryDetails;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/JobCard/SalaryDetails/index.tsx");
  reactHotLoader.register(SalaryDetails, "SalaryDetails", "/builds/bA1zbJom/0/gojob/ui-bits/src/JobCard/SalaryDetails/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/JobCard/SalaryDetails/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();